import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { IVisitLink } from 'src/app/shared/interfaces/visitLink';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ShamsiDatePipe } from 'src/app/shared/pipes/shamsiDatePipe';
import { ApiService } from 'src/app/shared/services/api.service';
import { DateService } from 'src/app/shared/services/date.service';

@Component({
  selector: 'app-visit-link',
  templateUrl: './visit-link.component.html',
  styleUrl: './visit-link.component.css'
})
export class VisitLinkComponent implements OnInit {


  visit: IVisitLink = {
    doctorName: '',
    startVisit: 0,
    visitDate: '',
    visitType: 1
  };
  visitId: any;
  todayDate: any;
  

  @ViewChild('modal') modal!: ModalComponent;

  constructor(private apiService: ApiService,
              private route: ActivatedRoute,
              private dateService: DateService,
              private dateShamsi: ShamsiDatePipe,
              private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.visitId = this.route.snapshot.params.visitId;
    this.todayDate = this.dateService.getTodayPersianDate();
    

    this.getVisitLink();
  }

  convertUTCMinutesToLocal(utcMinutes: number): number | any {
    // Get the current date (ignoring time) in UTC
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
  
    // Add UTC minutes to the date
    utcDate.setUTCMinutes(utcMinutes);
  
    // Convert to local time
    const localHours = utcDate.getHours(); // Local hours
    const localMinutes = utcDate.getMinutes(); // Local minutes
  
    // Convert local time to total minutes from 00:00 local time
    return this.calculateTime(localHours * 60 + localMinutes);
  }


  isTodayVisit() {
    const dateShamsi = this.dateShamsi.transform(this.visit.visitDate);
    if(dateShamsi==this.todayDate){
      return true
    }
  }

  isActiveVisitLink(): boolean {
    const dateShamsi = this.dateShamsi.transform(this.visit.visitDate);
    if(dateShamsi!=this.todayDate || this.getRemainingTime(this.visit.startVisit)>3){
      return true
    }
    
  }

  getVisitLink() {
    this.apiService.apiCall('get', '/api/PatientsVisitActive/'+ this.visitId +'/GetVisitInfoForConsultantById').subscribe((res: any) => {
      console.log(res);
      
      this.visit = res.body.model
    })
  }

  openVisitLink() {
    
    this.apiService.apiCall('post', '/api/User/OpenRoute/'+this.visitId, {}).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.apiService.apiCall('get', '/api/Doctor/GetCallRoute/'+this.visitId).subscribe((res: any) => {
          window.location.href = res.body.model;
          
        })
      }
    })
    
  }

  calculateTime(time) {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    // Format the time as HH:mm
    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return timeString
  }

  getRemainingTime(targetTime: number): number {
    // // Get current time
    // const now = new Date();
    // const currentMinutes = now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes
  
    // // Convert targetTime (HH:mm) to minutes
    // // const [targetHours, targetMinutes] = targetTime.split(':').map(Number);
    // // const targetTotalMinutes = targetHours * 60 + targetMinutes;
  
    // // Calculate remaining time
    // const remainingMinutes = targetTime - currentMinutes;
  
    // // If time has already passed, return 0
    // return remainingMinutes > 0 ? remainingMinutes : 0;

    // Get current local time in minutes
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes(); 

    // Convert targetTime (UTC minutes) to local minutes
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
    utcDate.setUTCMinutes(targetTime); // Add UTC minutes

    // Get local time in minutes
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const targetTimeLocal = localHours * 60 + localMinutes;

    // Calculate remaining time
    const remainingMinutes = targetTimeLocal - currentMinutes;

    // If the time has already passed, return 0
    return remainingMinutes > 0 ? remainingMinutes : 0;
  }

}
